import $ from 'jquery';

const loadYandexMapsScript = function() {
    const scriptTag = document.createElement('script');
    scriptTag.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU';
    scriptTag.type = 'text/javascript';

    document.head.appendChild(scriptTag);
};

const onMapReady = function() {
    map = new ymaps.Map('map')
}

const initMap = function(element, opts = {}, onload) {

    let interval = setInterval(function() {
        if(window.ymaps) {
            clearInterval(interval);

            ymaps.ready(function() {
                opts = $.extend(
                    {},
                    {
                        controls: ['zoomControl', 'fullscreenControl']
                    },
                    opts
                );

                const map = new ymaps.Map(element, opts || {})
                map.behaviors.disable('scrollZoom');

                if(typeof(onload) === 'function') {
                    onload(map)
                }
            })
        }

    }, 100);
}

export default function(element, opts, onload) {
    loadYandexMapsScript();
    initMap(element, opts, onload);
}